import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/government-contracting", label: "Government Contracting" },
  { to: "/industries", label: "Industries" },
  { to: "/insights", label: "Insights" },
  { to: "/contact", label: "Contact" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-gray-200"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center group">
          <img
            src="/assets/groman-logo.jpg"
            alt="Groman Associates — Your Vision, Our Expertise"
            className="h-11 md:h-12 w-auto"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-[13px] tracking-wide transition-colors gold-link ${
                  isActive ? "text-charcoal font-medium" : "text-charcoal-soft hover:text-charcoal"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex">
          <Link
            to="/contact"
            data-testid="header-cta-consultation"
            className="inline-flex items-center gap-2 bg-gold text-white px-5 py-3 text-[13px] font-medium tracking-wide hover:bg-gold-hover transition-colors"
          >
            Request a Consultation <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          className="lg:hidden p-2"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-gray-200 bg-white">
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `py-2 text-sm ${isActive ? "text-gold font-medium" : "text-charcoal"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-consultation"
              className="mt-2 inline-flex items-center justify-center gap-2 bg-gold text-white px-4 py-3 text-sm"
            >
              Request a Consultation <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
